import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';
import Button from '../Button';

const CallToActionSection = ({ heading, description, buttonText, buttonUrl }) => {
  const { isDarkMode } = useTheme();
  
  return (
    <section className={`relative py-24 overflow-hidden ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      {/* Background Color */}
      <div className={`absolute inset-0 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`} />

      {/* Top Gradient Line */}
      <div className="absolute top-0 left-0 right-0 flex justify-center">
        <div className="w-[60%] h-[1px] bg-gradient-to-r from-transparent via-[#FCD535] to-transparent" />
      </div>

      {/* Glow Effect */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] opacity-30"
        style={{
          background: 'radial-gradient(50% 50% at 50% 50%, #E8C431 0%, rgba(232, 196, 49, 0.00) 100%)',
          filter: 'blur(60px)',
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center max-w-[80%] mx-auto">
          <motion.h2 
            className="text-[30px] font-medium text-black dark:text-white mb-6 font-lexend leading-[48px] tracking-[0%]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            {heading}
          </motion.h2>

          <motion.p 
            className="text-[18px] font-light text-black/80 dark:text-white/80 mb-12 font-lexend leading-[28px] tracking-[0%] max-w-[80%]"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            {description}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <Button 
              text={buttonText}
              link={buttonUrl}
              variant="gradient"
              size="lg"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection; 